const e = "styles-module__insurance___HNqE6", n = {
  insurance: e,
  "insurance-warning-container": "styles-module__insurance-warning-container___BebSf",
  "insurance-warning": "styles-module__insurance-warning___A6ZOL",
  "insurance-sales-terms": "styles-module__insurance-sales-terms___iu9Ke",
  "insurance-title-container": "styles-module__insurance-title-container___5hSlv",
  "insurance-title-container-mobile": "styles-module__insurance-title-container-mobile___RHKzK",
  "insurance-title": "styles-module__insurance-title___L-YAM",
  "insurance-price": "styles-module__insurance-price___s31H3",
  "insurance-price-mobile": "styles-module__insurance-price-mobile___bunUP"
};
export {
  n as default,
  e as insurance
};
